// extracted by css-extract-rspack-plugin
export default {"message":"A91uNl","countdown":"bDfk4h","countdown-value":"G5YvT4","countdownValue":"G5YvT4","countdown-ended":"P2E39L","countdownEnded":"P2E39L"};